@if (show) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>
          <fa-icon [icon]="faCog"></fa-icon>
          <span>{{ displayName }} · {{ 'CONFIGURATIONS.DETAILS_TAB' | translate }}</span>
        </h3>
        <button class="close-btn" (click)="onClose()">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>

      <div class="modal-body">
        <section class="details-section">
          <h4 class="details-section-title">{{ 'CONFIGURATIONS.GENERAL_INFO' | translate }}</h4>
          <div class="details-grid">
            <div class="details-field">
              <span class="details-label">{{ 'CONFIGURATIONS.FORM.NAME' | translate }}</span>
              <span class="details-value">{{ configuration?.key }}</span>
            </div>
            @if (configuration?.name) {
              <div class="details-field">
                <span class="details-label">{{ 'CONFIGURATIONS.FORM.DISPLAY_NAME' | translate }}</span>
                <span class="details-value">{{ configuration?.name }}</span>
              </div>
            }
            <div class="details-field">
              <span class="details-label">{{ 'CONFIGURATIONS.FORM.TYPE' | translate }}</span>
              <span class="details-value">{{ typeLabelKey(configuration?.type) | translate }}</span>
            </div>
            <div class="details-field">
              <span class="details-label">{{ 'CONFIGURATIONS.FORM.CREATED_AT' | translate }}</span>
              <span class="details-value">{{ configuration?.created_at | date:'short' }}</span>
            </div>
            <div class="details-field">
              <span class="details-label">{{ 'CONFIGURATIONS.FORM.UPDATED_AT' | translate }}</span>
              <span class="details-value">{{ configuration?.updated_at | date:'short' }}</span>
            </div>
          </div>
        </section>

        @if (valueKeys.length) {
          <section class="details-section">
            <h4 class="details-section-title">{{ 'CONFIGURATIONS.PARAMETERS' | translate }}</h4>
            <div class="details-grid">
              @for (key of valueKeys; track key) {
                <div class="details-field">
                  <span class="details-label">{{ labelKey(key) | translate }}</span>
                  <span class="details-value">{{ valueLabelKey(key, configuration?.value[key]) | translate }}</span>
                </div>
              }
            </div>
          </section>
        }
      </div>
    </div>
  </div>
}
